import { jsx } from 'react/jsx-runtime';
import cn from 'classnames';
import { Scroll } from '../../Scroll/Scroll.js';
import List from './List.js';
import S from './ListScroll.styl.js';

function ListScroll({ scrollProps, ...rest }) {
    const innerClassName = cn(scrollProps.x && S.x, scrollProps.y && S.y);
    const props = {
        ...scrollProps,
        innerClassName,
    };
    return (jsx(List, { ...rest, customWrapElem: {
            component: Scroll,
            props,
            // @ts-ignore
            getRef: ref => ref.innerElem,
        } }));
}

export { ListScroll as default };
